// IncidentField.ts
import * as ko from 'knockout';
import { getQueryParams } from '../utils';
export function createIncidentField(data) {
    const params = getQueryParams();
    let defaultValue = '';
    // Check for specific suffix and assign the default value if a query parameter exists
    for (const [key, value] of Object.entries(params)) {
        if (data.name.toLowerCase().endsWith(key)) {
            defaultValue = value;
            break;
        }
    }
    // Pre-populate Schadentag fields with today's date in DD.MM.YYYY format
    if (!defaultValue && data.name.toLowerCase().endsWith('schadentag')) {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();
        defaultValue = `${dd}.${mm}.${yyyy}`;
    }
    // Map your API response to the IncidentField structure
    return {
        label: data.label,
        name: data.name,
        type: data.type,
        value: ko.observable(defaultValue), // Initialize with default value if applicable
        required: false //data.label.includes('Pflichtfeld') // Set required based on label
    };
}
